import { Alert, AlertType } from "@/atoms-react/alert/index.react";
import Loader from "@/atoms-react/loader/Loader.react";
import { InfoAlert } from "@/atoms-react/text/Text.react";
import config from "@/config";
import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";
import { WalletData } from "@/features/kypay/types";
import { identityPartners } from "@/features/user/types";
import { setConfirmationCreateWallet } from "@/redux/slices/transfertActionSlice";
import { useLogin, usePrivy } from "@privy-io/react-auth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
type PrivyAlertLoginPropsType = {
  walletData: WalletData | undefined;
  identityPartner: identityPartners | null;
  isTokenyWalletFailed?: boolean;
};
export const AlertLoginPrivy = ({
  walletData,
  identityPartner,
  isTokenyWalletFailed
}: PrivyAlertLoginPropsType) => {
  const origin = useOrigin();
  const { ready, authenticated, user } = usePrivy();
  const [timedOut, setTimedOut] = useState(false);
  useEffect(() => {
    // Si Privy met plus de 3 secondes à répondre, on force le rendu a du vide pour ne pas laisser le loader
    const timer = setTimeout(() => {
      if (!ready) setTimedOut(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [ready]);

  const dispatch = useDispatch();
  const { t } = useTranslation(["wallet"]);

  const { login } = useLogin({
    onComplete: ({ user }) => {
      if (!walletData && !isTokenyWalletFailed && !!user)
        dispatch(setConfirmationCreateWallet(true));
    }
  });

  const handleLoginPrivy = async () => {
    if (ready && authenticated && user && !walletData && !isTokenyWalletFailed && user.wallet) {
      dispatch(setConfirmationCreateWallet(true));
    } else if (ready) login();
    return;
  };

  const showAlert =
    ready &&
    walletData &&
    walletData.walletConnect &&
    !authenticated &&
    !isTokenyWalletFailed &&
    !!config.USE_PRIVY &&
    ((origin === FromURL.Partner &&
      identityPartner?.mode === "TOKEN" &&
      !!identityPartner?.token?.address) ||
      origin === FromURL.None);

  if (!ready && !timedOut) {
    return <Loader />;
  }
  return !ready && !timedOut ? (
    <Loader />
  ) : !ready && timedOut ? (
    <></>
  ) : (
    showAlert && (
      <Alert
        title={t("wallet:kypay.modal_add_wallet.label.title")}
        className="mt-4"
        type={AlertType.Info}
      >
        <InfoAlert>
          <p>
            {t("wallet:kypay.label.warning2", { address: walletData.walletAddress })}
            <a
              className="ml-1 cursor-pointer font-bold underline"
              onClick={async () => {
                await handleLoginPrivy();
              }}
            >
              {t("wallet:kypay.label.warning2_button")}
            </a>
          </p>
        </InfoAlert>
      </Alert>
    )
  );
};
